import React from "react";
import { Menu, MenuItem } from '@progress/kendo-react-layout';
import { useNavigate } from 'react-router-dom';

export const MainLayout = (props) => {

    return (
        <div className="container">
            <MainMenu />
            {props.children}
        </div>
    );
};


const MainMenu = (props) => {
    const navigate = useNavigate();

    const onSelect = (event) => {
        navigate(event.item.data.route);
    };

    return (
        <div>
            
        </div>
    );
};
